import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Button} from "primereact/button";
import axios from "axios";
import Cookies from "js-cookie";
import moment from "moment";

import HelpComponent from "../HelpComponent";

const _FM_PaymentmethodShowComponent = (props) => {

  const {t} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  const [formData, setFormData] = useState({});
  const [CFormData, setCFormData] = useState({});
  const [CFields, setCFields] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (formData._country_specifics) {
      let countryObjectName = "payment_method_" + Object.keys(formData._country_specifics)[0].toLowerCase() + "s";
      if (formData[countryObjectName][0] && formData[countryObjectName][0].id) {
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "payment-method-"
            + Object.keys(formData._country_specifics)[0].toLowerCase() + "/" + formData[countryObjectName][0].id,
          params: {},
          headers: {
            'Authorization': 'Bearer ' + Cookies.get("userToken"),
            "Sys-name": Cookies.get("instanceId"),
            "Preferred-locale": Cookies.get("language")
          }
        })
          .then(response => {
            setCFormData(response.data.data);
            const transformedCountry = Object.keys(formData._country_specifics)[0]
              ? Object.keys(formData._country_specifics)[0].charAt(0).toUpperCase() + Object.keys(formData._country_specifics)[0].slice(1).toLowerCase() : "";
            axios({
              method: 'get',
              url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "info/PaymentMethod" + transformedCountry,
              params: {},
              headers: {
                'Authorization': 'Bearer ' + Cookies.get("userToken"),
                "Sys-name": Cookies.get("instanceId"),
                "Preferred-locale": Cookies.get("language")
              }
            })
              .then(response => {
                setCFields(response.data.editable_fields);
              })
              .catch(error => {
                window.App.toastShow('error', t('error'), error.toString(), '', error.response);
              })
          })
          .catch(error => {
            window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          })
      }
    }
  }, [formData._country_specifics])

  useEffect(() => {
    if (id) {
      setLoading(true)
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "payment-method/" + id,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setLoading(false)
          setFormData(response.data.data);
          window.App.setState({rerenderBerthList: false})
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
  }, [window.App.state.rerenderBerthList === true])

  return (
    <>
      <div className={"p-grid p-mt-3"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>
        {formData.name || t('paymentmethod_show')}
          </h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          <Button type="button" aria-label={t('edit')}
                  icon={"pi pi-pencil"}
                  onClick={() => {
                    navigate('/payment-method/')
                    setTimeout(() => {
                      navigate('/payment-method/update/' + id)
                    }, 500)
                  }}
                  className="p-button-warning p-ml-2">
          </Button>
          <Button type="button"
                  icon={"pi pi-times"}
                  onClick={() => {
                    navigate(-1)
                  }}
                  className="p-button-secondary close p-ml-2">
          </Button>
        </div>
      </div>
      <div className={"p-grid"}>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('created_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
        <div className={"p-col"}>
          <small className={"p-text-uppercase"}>
            {t('updated_at')}
          </small>
          <p className={"p-mt-0 p-mb-0 p-text-bold"}>
            {moment.utc(formData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}
          </p>
        </div>
      </div>
      {CFields && CFields[0] &&
        <>
          <Panel className={"p-mt-3"}>
            <h3 className={"p-mt-0"}>
              {Object.keys(formData._country_specifics)[0].toUpperCase()}
            </h3>
            <div className={"p-grid"}>
              {CFields.map((field, index) => {
                if (field.name && (typeof CFormData[field.name] === 'string' || typeof CFormData[field.name] === 'number')) {
                  return (
                    <div className={"p-col-12 p-lg-6"} key={index}>
                      <div className="p-field p-fluid">
                        <label htmlFor={field.name}>{t(field.name)}</label>
                        <span className="p-d-block p-text-bold">
                          {t(CFormData[field.name].toLowerCase())}
                        </span>
                      </div>
                    </div>
                  )
                }
              })}
            </div>
          </Panel>
        </>
      }
    </>
  )
}
export default withTranslation('common')(_FM_PaymentmethodShowComponent);
